var NOTIF_CONTAINER_POSITIONS = ['top-right', 'top-left', 'bottom-left', 'bottom-right'];

export { NOTIF_CONTAINER_POSITIONS };
